import t from '../helpers/translate';
import Prompt from './Prompt';

type Props = {
  onWithLocationClick: () => void;
  onWithoutLocationClick: () => void;
};

const OnboardingPrompt = ({ onWithLocationClick, onWithoutLocationClick }: Props) => (
  <Prompt>
    <h1>{t('Find places to Fish & Boat in your area')}</h1>
    <p>
      {t(
        'Press "Explore your location" to start exploring your current area. You may be prompted to allow sharing of your location to use this feature.',
      )}
    </p>
    <button type="button" className="btn-submit btn-primary" onClick={onWithLocationClick}>
      {t('Explore your location')}
    </button>
    <button type="button" className="btn-submit btn-secondary" onClick={onWithoutLocationClick}>
      {t('Explore entire U.S.')}
    </button>
  </Prompt>
);

export default OnboardingPrompt;
